export interface PublicMapLayerSettings {
  enabled: boolean;
  sourceId?: string;
  sourceLayerId?: string;
  geometry?: string;
  label?: string;
}

export interface PublicMapSettings {
  enabled: boolean;
  statusMapEnabled?: boolean;
  defaultHostname?: string;
  hostnames: string[];
  customHostnames: string[];
  layers: Record<string, PublicMapLayerSettings>;
}

export interface TenantPublicMapSettingsResponse {
  tenantId: string;
  dnsTarget?: string;
  requestAccessUrl?: string;
  sharedSiteUrl?: string;
  sharedEmbedUrl?: string;
  sharedStatusSiteUrl?: string;
  canManage: boolean;
  settings: PublicMapSettings;
}

async function readJSON<T>(response: Response): Promise<T> {
  if (response.status === 204) {
    return undefined as T;
  }
  return response.json() as Promise<T>;
}

async function request<T>(path: string, init?: RequestInit): Promise<T> {
  const response = await fetch(path, {
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...(init?.headers ?? {}),
    },
    ...init,
  });

  if (!response.ok) {
    let message = `Request failed with status ${response.status}`;
    try {
      const body = await response.json() as { message?: string; detail?: string; title?: string };
      message = body.message || body.detail || body.title || message;
    } catch {
      // ignore response parse errors
    }
    throw new Error(message);
  }

  return readJSON<T>(response);
}

export function getTenantPublicMapSettings(tenantId: string): Promise<TenantPublicMapSettingsResponse> {
  return request<TenantPublicMapSettingsResponse>(`/api/v1/tenants/${encodeURIComponent(tenantId)}/public-map-settings`);
}

export function updateTenantPublicMapSettings(
  tenantId: string,
  settings: PublicMapSettings,
): Promise<TenantPublicMapSettingsResponse> {
  return request<TenantPublicMapSettingsResponse>(`/api/v1/tenants/${encodeURIComponent(tenantId)}/public-map-settings`, {
    method: 'PUT',
    body: JSON.stringify({ settings }),
  });
}
